import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ApiPaths } from '@gah-core/constants/api-paths.enum';
import { TranslateService } from '@ngx-translate/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class HomeService {
  apiUrl = environment.apiUrl;
  constructor(private http: HttpClient, private translate: TranslateService) {}

  /**
   * Performs fetching of home page release information(GAHR82)
   */
  fetchHomePageReleaseData(territoryId: number, groupTypeCode: string): Observable<any> | null {
    let params = new HttpParams()
      .set('territoryId', territoryId)
      .set('groupTypeCode', groupTypeCode);

    return this.http.get<any>(`${this.apiUrl}/${ApiPaths.FetchHomePageData}`, { params }).pipe(
      map((res) => {
        return res;
      }),
      catchError((error) => this.handleError(error))
    );
  }

  /**
   * Performs fetching of home page header media information(GAHR82)
   */
  fetchHomePageHeaderMediaData(groupTerritoryId: number): Observable<any> | null {
    let params = new HttpParams().set('groupTerritoryId', groupTerritoryId);

    return this.http
      .get<any>(`${this.apiUrl}/${ApiPaths.FetchHomePageHeaderMediaData}`, { params })
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((error) => this.handleError(error))
      );
  }

  fetchTitlesForRecentPublished(groupTerritoryId: number): Observable<any> | null {
    let params = new HttpParams().set('groupTerritoryId', groupTerritoryId);
    return this.http
      .get<any>(`${this.apiUrl}${ApiPaths.FetchTitlesForRecentPublished}`, { params })
      .pipe(catchError((error) => this.handleError(error)));
  }

  /**
   * @param error HttpErrorResponse object
   */
  private handleError(error: HttpErrorResponse) {
    let errorMsg: {
      message: string;
      errorCode: number;
    } = {
      message:
        error.error && error.error.errorDescription
          ? error.error.errorDescription
          : this.translate.instant('unknown-error-msg-text'),
      errorCode: error.status,
    };
    return throwError(errorMsg);
  }
}
